import { getFieldsHavingWellDataApi, getWellsHavingDataByFieldIdApi } from '@core/core/api'
import type { FieldId } from '@core/core/types'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const loadHotStorageFieldsHavingWellsData = createAsyncThunk(
  'hotStorage/loadFieldsHavingWellData',
  () => getFieldsHavingWellDataApi(),
)

export const loadHotStorageWellsHavingDataForField = createAsyncThunk(
  'hotStorage/loadWellsHavingDataForField',
  async (fieldId: FieldId) => {
    const wells = await getWellsHavingDataByFieldIdApi(fieldId)
    return { fieldId, wells }
  },
)
